import { Component, Inject, OnInit } from '@angular/core';

import { NotificationService } from '@upr-web-primer/notification';
import { get } from '@upr-web-primer/udx-utils';
import { CommonUtilityService } from '../../services/common-utility.service';

@Component({
  selector: 'app-reservation-error-page',
  templateUrl: './reservation-error-page.component.html',
  styleUrls: ['./reservation-error-page.component.scss'],
  standalone: false,
})
export class ReservationErrorPageComponent implements OnInit {
  /**
   * Page labels
   * @type any
   */
  pageLabels: any;

  backLink: string;
  errorImage: string;
  /**
	 * Constructor
	 * @param {ActivatedRoute} route

	 * @param {any} appRoutes
	 */
  constructor(
    private readonly common: CommonUtilityService,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('AppRoutes') private readonly appRoutes: any,
    private readonly notification: NotificationService,
  ) {}
  ngOnInit(): void {
    this.pageLabels = this.common.getResolvedPageData();
    this.errorImage =
      this.pageLabels?.['linkReservation.unable_to_retrieve_reservation.image'];
  }

  buttonEventHandler(event: any): void {
    const btnData = get(event, 'detail.data');
    if (btnData.type === 'secondary') {
      this.common.changeRoute(this.appRoutes.LINK_RESERVATIONS);
      this.notification.hide();
    } else if (btnData.type === 'tertiary') {
      this.common.changeRoute(this.appRoutes.DASHBOARD);
      this.notification.hide();
    } else {
      return;
    }
  }
  goToLinkReservations(): void {
    this.common.changeRoute(this.appRoutes.LINK_RESERVATIONS);
  }
}
